export default __webpack_public_path__ + "b3cb4ab16a73eb76b431e8056a183fd2.png";